import "../../styles/layout.scss";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { IconButton, Badge } from "@mui/material";
import { NotificationsList } from "../NotificationsList";
import { useRef, useState } from "react";
import { useUnit } from "effector-react";
import { $pushNotifications } from "../../store/pushNotifications";

export const Footer = () => {
    const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
    const notificationButtonRef = useRef(null);

    const pushNotifications = useUnit($pushNotifications);

    const handleNotificationsClick = () => {
        setIsNotificationsOpen(!isNotificationsOpen);
    };

    const handleCloseNotifications = () => {
        setIsNotificationsOpen(false);
    };

    return (
        <div className="layout__footer">
            <IconButton 
                ref={notificationButtonRef}
                onClick={handleNotificationsClick}
                className={isNotificationsOpen ? 'active' : ''}
            >
                <Badge badgeContent={pushNotifications.filter(notification => !notification.isRead).length} color="primary">
                    <NotificationsNoneIcon fontSize="medium" className="layout__footer__icon" style={{margin: 0}} />
                </Badge>
            </IconButton>
            <IconButton>
                <ChatBubbleOutlineIcon fontSize="medium" className="layout__footer__icon" style={{margin: 0}} />
            </IconButton>

            <NotificationsList 
                isOpen={isNotificationsOpen}
                onClose={handleCloseNotifications}
                anchorEl={notificationButtonRef.current}
            />
        </div>
    )
}